import urlUtils from '../utils/rbmc.url-utils.js';
import logger from '../utils/rbmc.logger';
import pdpPlayerPersonalization from './rbmc.pdp-player-personalization';
import pdpConfig from './rbmc.pdp-configurator-field';
import pdpCustomPersonalization from './rbmc.pdp-custom-personalization';
import pdpTooltips from './rbmc.pdp-tooltips';
import productDetails from './rbmc.pdp';
import pdpPatches from "./rbmc.pdp-sponsor-patches";
import pdpPreselect from "./rbmc.pdp-preselect";
import notifyMe from "./rbmc.notify-me";
import pdpFlockingWFL from './rbmc.wfl-flocking';
import pdpSlider from './rbmc.pdp-slider';
import pdpImageGallery from './rbmc.pdpImageGallery';
import pdpBlacklist from './rbmc.pdp-blacklist';

const pdpLoadProduct = {
    pendingXHR: 0,
    loadProduct() {
        let variantData = $('#variantData'),
            variantCode = variantData.data('initial-variant-code'),
            name        = pdpPreselect.urlString.searchParams.get('preselectedFlockName'),
            number      = pdpPreselect.urlString.searchParams.get('preselectedFlockNumber');

        pdpLoadProduct.showVariantCode(variantCode);

        if (RedBull.config.employee && RedBull.config.employee.restrictedUserGroups) {
            $.ajax({
                url:    `${urlUtils.getBaseUrl()}restrictedpdp/${RedBull.config.employee.baseId}/`,
                method: 'GET',
                cache:  false
            }).then((data) => {
                // allowed to fetch product data
                pdpLoadProduct.loadProductWithCodeAndParams(variantCode, name, number);
                productDetails.trackProductDetail();
            }, (jqXHR) => {
                //restricted site not available for the user -> redirect
                window.location.replace(urlUtils.getBaseUrl());
            });
        } else {
            pdpLoadProduct.loadProductWithCodeAndParams(variantCode, name, number);
        }
    },
    loadProductWithCodeAndParams(variantCode, preselectedFlockName, preselectedFlockNumber) {
        let url = `${urlUtils.getBaseUrl()}p/${variantCode}/variantData/`;
        if (!!preselectedFlockName !== false && !!preselectedFlockNumber !== false) {
            url = `${url}?preselectedFlockName=${preselectedFlockName}&preselectedFlockNumber=${preselectedFlockNumber}`;
        }

        let request = $.ajax({
            url:    url,
            method: 'GET',
            cache:  false
        });

        request.done((response) => {
            $('#productInfoPanel').replaceWith(response);
            pdpLoadProduct.init();
            pdpPreselect.init();
            notifyMe.init();
            pdpFlockingWFL.init();
            productDetails.trackProductDetail();
        });

        pdpLoadProduct.showVariantCode(variantCode);
        request.fail(function (x, e) {
            logger.debug('Cannot fetch product data from backend');
        });
    },
    loadProductData(variantCode, preselectedFlockName, preselectedFlockNumber) {
        const url = new URL(`${urlUtils.getSiteOrigin()}${urlUtils.getBaseUrl()}p/${variantCode}/variantData`);
        if (preselectedFlockName) {
            url.searchParams.set('preselectedFlockName', preselectedFlockName);
        }
        if (preselectedFlockNumber) {
            url.searchParams.set('preselectedFlockNumber', preselectedFlockNumber);
        }

        return $.ajax({
            url:         url,
            method:      'GET',
            contentType: 'application/json',
            dataType:    'json',
            cache:       false
        });
    },
    sizeBindHandler() {
        productDetails.productInfoPanel.on('changed.bs.select', '#pdp__select-option', (e, clickedIndex, isSelected, previousValue) => {
            let dataSet = e.target[clickedIndex].dataset;
            pdpLoadProduct.refreshVariantStatuses(dataSet.productCode, [
                '.pdp__stock-info',
                '.pdp__add-to-cart-button-wrapper',
                '.pdp__color-selector',
                '.pdp__item-price-info',
                '#pdp__gtm'
            ]);
        });
    },

    colorVariantBindHandler() {
        productDetails.productInfoPanel.on('click',
                '.pdp__color-selector__color:not(.pdp__color-selector__color--active)', (e) => {
                    let productVariantCode = e.currentTarget.dataset.productCode;
                    pdpLoadProduct.refreshVariantStatuses(productVariantCode, [
                        '.pdp__stock-info',
                        '.pdp__add-to-cart-button-wrapper',
                        '.pdp__color-info',
                        '#pdp__select-option-wrapper',
                        '#pdp__current-product',
                        '#pdp__cdn-media-url',
                        '#pdp__gtm'
                    ]);
                    pdpLoadProduct.refreshSliderImages(productVariantCode);
                    productDetails.productInfoPanel
                                  .find('.pdp__color-selector__color--active')
                                  .removeClass('pdp__color-selector__color--active');
                    $(e.currentTarget).addClass('pdp__color-selector__color--active');
                });
    },

    refreshVariantStatuses(variantCode, sections) {
        let url               = `${urlUtils.getBaseUrl()}p/${variantCode}/variantData/`,
            $productInfoPanel = $('#productInfoPanel');
        // save the configurator status because the gtm object will loaded new from backend. They can be changes on variants (eg. price)
        // FIXME: race condition in rbmc.pdp-preselect.js line 22
        // variable to track pending XHR calls for variant data. For tracking only the last call can be tracked
        this.pendingXHR++;

        $.get(url, response => {
            $.each(sections, (index, section) => {
                $productInfoPanel.find(section)
                                 .replaceWith($(response).find(section));
            });
        }).then(() => {
            productDetails.infoTextVisibility();
            $('#pdp__select-option').selectpicker();
            //use pdpPreselect.variantSelector
            $('#productCode').val(variantCode);
            pdpLoadProduct.showVariantCode(variantCode);
            this.pendingXHR--;
            if (this.pendingXHR === 0) {
                // no pending XHR calls. The GTM data is now stable (not necessary correct!) and can be tracked
                // productDetails.trackProductDetail();
            }
        });
    },

    //used for reinitializing slider area when color picker throw change
    //check if product is flockable and have flocking enabled
    refreshSliderImages(variant) {
        const url = `${window.location.pathname}?preselectedVariant=${variant} .pdp__slider-area > *`;
        pdpSlider.pdpSliderArea
                 .addClass('pdp__slider--reload')
                 .load(url, (response) => {
                     pdpSlider.destroySliders();
                     pdpSlider.cacheSelectors();
                     pdpSlider.initiateSliders();
                     pdpSlider.bindHandler();
                     pdpConfig.initDefaults();
                     productDetails.cacheSelectors();
                     pdpCustomPersonalization.cacheSelectors();
                     pdpPlayerPersonalization.cacheSelectors();
                     if (pdpConfig.playerChosenFlag) {
                         pdpPlayerPersonalization.setPlayerPersonalization(
                                 pdpPlayerPersonalization.selectPlayerOption.prop('selectedIndex')
                         );
                     }
                     if (pdpConfig.customNameFlag) {
                         pdpCustomPersonalization.savePersonalizationFn(false);
                     }
                     pdpSlider.pdpSliderArea.removeClass('pdp__slider--reload');
                     // RBMC-3254
                     pdpImageGallery.exchangeImageGallery(response);
                 });
    },

    showVariantCode(variant) {
        $('.pdp__product-code').text(variant);
    },

    init() {
        pdpBlacklist.fetchBlacklist();
        pdpPlayerPersonalization.init();
        pdpConfig.init();
        productDetails.init();
        pdpLoadProduct.colorVariantBindHandler();
        pdpLoadProduct.sizeBindHandler();
        pdpCustomPersonalization.init();
        pdpPatches.init();
        pdpTooltips.init();
        notifyMe.bindEvents();
    }
};

export default pdpLoadProduct;
